import React from 'react';
import { Location } from 'history';
import { Link as RouteLink, LinkProps as RouteLinkProps } from 'react-router-dom';
import { Link } from '@instructure/ui-link';
import { Button } from '@instructure/ui-buttons'

export const isModalLoc = (location: Location<any>) => location.state && location.state.modal;

const ABS_URL = new RegExp('^(?:[a-z]+:)?//', 'i');

// InstUI 8: Button dropped the `variant` prop in favour of `color` +
// `withBackground`/`withBorder`, and renders icons via `renderIcon` (not `icon`).
// Map the legacy v6 variant values used across SmartLink call sites so behavior
// is preserved without touching every call site.
const mapButtonProps = (props: Record<string, any>) => {
    const { variant, icon, ...rest } = props;
    switch (variant || 'link') {
        case 'primary': rest['color'] = 'primary'; break;
        case 'secondary': rest['color'] = 'secondary'; break;
        case 'success': rest['color'] = 'success'; break;
        case 'danger': rest['color'] = 'danger'; break;
        case 'default': rest['color'] = 'secondary'; break;
        // v6 'ghost' / 'link' were transparent, primary-coloured buttons
        case 'ghost':
        case 'link':
        default:
            rest['color'] = 'primary';
            rest['withBackground'] = false;
            break;
    }
    if (icon !== undefined) rest['renderIcon'] = icon;
    return rest;
}

export const resolveLink = (link: RouteLinkProps['to'], inProps?, children?) => {
    const { active, button, ...rawProps } = inProps;
    if (children) rawProps['children'] = children;

    const props = button ? mapButtonProps(rawProps) : rawProps;
    if (!button && props['isWithinText'] == undefined) props['isWithinText'] = false;

    const Component: any = button ? Button : Link;

    if (active === false) return <span {...props} />;
    if (typeof link == 'function') return <Component onClick={link} {...props} />
    if (link && typeof link == 'string' && ABS_URL.test(link)) return <Component target="_parent" href={link} {...props} />
    if (link) return <Component as={RouteLink} to={link} {...props} />
    return <span {...props} />;
}

interface SmartLinkProps extends Partial<RouteLinkProps> {
    to?: RouteLinkProps['to'],
    active?: boolean,
    button?: boolean,

    [key: string]: any
}

export const SmartLink: React.FunctionComponent<SmartLinkProps> = ({ to, ...rest }) => {
    return resolveLink(to, rest);
}
